import { Expose } from "class-transformer";
import { IsDate, IsDefined, IsNumber, IsString, IsUUID } from "class-validator";

import { GObjectType, GInputType, GField, GInt } from "../graphql";
import { CDBaseEntity } from "../orm";
import { TransformToDate } from "../transformers/transformToDate";

@GObjectType("CustomerFeedbackStop")
@GInputType("CustomerFeedbackStopInput")
export class CustomerFeedbackStop extends CDBaseEntity {
    @GField()
    @IsUUID("4")
    @Expose()
    public locationId: string;

    @GField()
    @IsDate()
    @IsDefined()
    @Expose()
    @TransformToDate
    public createdAt: Date = new Date(); // requested at

    @GField(() => GInt)
    @IsNumber()
    @Expose()
    public score: number;

    @GField()
    @IsString()
    @Expose()
    public text: string;
}
